import gql from 'graphql-tag';

import history from '../../core/history';
import {
  BOOKING_PROCESS_START,
  BOOKING_PROCESS_SUCCESS,
  BOOKING_PROCESS_ERROR,
} from '../../constants';

export function bookingProcess(
  listId,
  guests,
  startDate,
  endDate,
  preApprove,
  units,
) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: BOOKING_PROCESS_START,
      payload: {
        bookingLoading: true,
      },
    });

    try {
      let query = gql`
        query UserListing($listId: String!) {
          UserListing(listId: $listId) {
            id
            userId
            title
            coverPhoto
            basePrice
            category
            listingAddresses {
              city
              state
            }
            listPhotos {
              id
              name
            }
            user {
              email
              profile {
                profileId
                displayName
                firstName
                picture
              }
            }
            listingRules {
              listingRulesId
              description
            }
          }
        }
      `;

      const { data } = await client.query({
        query,
        variables: {
          listId,
        },
      });

      if (data && data.UserListing) {
        // console.log('bookingProcess - units', units);
        dispatch({
          type: BOOKING_PROCESS_SUCCESS,
          payload: {
            data: data.UserListing,
            bookDetails: {
              guests,
              startDate,
              endDate,
              preApprove,
              units,
            },
            bookingLoading: false,
          },
        });
        history.push('/book/' + listId);
      }
    } catch (error) {
      dispatch({
        type: BOOKING_PROCESS_ERROR,
        payload: {
          error,
          bookingLoading: false,
        },
      });
      return false;
    }

    return true;
  };
}



// WEBPACK FOOTER //
// ./src/actions/booking/bookingProcess.js